import React from 'react';
import { Button } from './Button';

export interface ErrorStateProps {
  title?: string;
  message?: string;
  onRetry?: () => void;
  className?: string;
}

export const ErrorState = ({ title = 'Đã có lỗi xảy ra', message = 'Không thể tải dữ liệu, vui lòng thử lại sau.', onRetry, className = '' }: ErrorStateProps) => {
  return (
    <div className={`flex flex-col items-center justify-center p-8 text-center bg-red-50/50 rounded-xl border border-red-100 ${className}`}>
      <div className="w-16 h-16 flex items-center justify-center bg-red-100 rounded-full mb-4">
        <i className="ri-error-warning-line text-3xl text-red-500"></i>
      </div>
      <h3 className="text-sm font-medium text-gray-900 mb-1">{title}</h3>
      <p className="text-sm text-gray-500 max-w-md mb-4">{message}</p>
      {onRetry && (
        <Button variant="outline" onClick={onRetry} className="border-red-200 text-red-600 hover:bg-red-50">
          <i className="ri-refresh-line mr-2"></i> Thử lại
        </Button>
      )}
    </div>
  );
};
